<template>
  <div class="ranking-setting-section" :class="`ranking-setting-section--${screenOrientationType}`">
    <div class="ranking-setting-section__inner">
      <ranking-flag-parts class="ranking-setting-section__flag" :value="flagType" />

      <label
        class="ranking-setting-section__leader"
        :class="{ 'ranking-setting-section__leader--disabled': rankingViewMode !== 'gap' }"
      >
        <atom-input-checkbox
          class="fieldset-checkbox-parts__input"
          :value="leader"
          color="dark"
          @input="toggleLeader"
        />
        <span>Leader</span>
      </label>

      <view-mode-selector-parts
        class="ranking-setting-section__data-select"
        :rankingViewMode="rankingViewMode"
        :rankingViewModeList="rankingViewModeList"
        @rankingViewModeChange="changeRankingViewMode"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import RankingFlagParts from '@/components/RaceVideoPage/RaceVideoRankingPane/parts/RankingFlagParts.vue'
import ViewModeSelectorParts from '@/components/RaceVideoPage/RaceVideoRankingPane/parts/ViewModeSelectorParts.vue'
import AtomInputCheckbox from '@/components/atoms/input/AtomInputCheckbox.vue'
import { RankingViewMode } from '@/components/RaceVideoPage/RaceVideoRankingPane.vue'

/**
 * レース動画再生画面 ランキング表示設定セクションのコンポーネント
 */
export default defineComponent({
  name: 'RankingSettingSection',
  components: {
    RankingFlagParts,
    AtomInputCheckbox,
    ViewModeSelectorParts,
  },
  props: {
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    /**
     * Flag情報
     */
    flagType: {
      type: String,
      default: '',
    },
    /**
     * Leader表示状態
     */
    leader: {
      type: Boolean,
      default: false,
    },
    /**
     * データ表示モード指定
     */
    rankingViewMode: {
      type: String as PropType<RankingViewMode>,
      required: true,
      default: 'gap',
    },
    /**
     * データ表示モード一覧
     */
    rankingViewModeList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  methods: {
    /**
     * チェックボックス押下
     */
    toggleLeader() {
      this.$emit('leaderToggle')
    },
    /**
     * 表示データ切り替え
     * @param mode: string
     */
    changeRankingViewMode(mode: RankingViewMode) {
      this.$emit('rankingViewModeChange', mode)
    },
  },
})
</script>

<style lang="scss" scoped>
.ranking-setting-section {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  background: $black80;

  &__inner {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    gap: min(4.8vw, 18px);
    height: 44px;
    width: min(100%, 375px);
    padding: 0 min(5.33vw, 20px);
    margin: 0 auto;
  }

  &__leader {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    font-size: 12px;
    color: #fff;
    cursor: pointer;

    &--disabled {
      pointer-events: none;
      opacity: 0.1;
    }
  }

  &__data-select {
    width: calc(100% - 90px - #{min(9.6vw, 36px)});
  }

  &--landscape-primary,
  &--landscape-secondary {
    font-size: 10px;

    .ranking-setting-section {
      &__inner {
        gap: 8px;
        width: 100%;
        padding: 0 8px;
      }

      &__data-select {
        width: calc(100% - 101px);
      }
    }
  }
}
</style>

<style lang="scss">
.ranking-setting-section {
  &__data-select {
    .view-mode-selector-parts__select {
      width: 100%;
    }
  }
}
</style>
